import { DocumentSnapshot, addDoc, collection, getDocs, query, updateDoc, where } from 'firebase/firestore';
import { IInventory, IMaterialInventory, InventoryStatusFile } from '../sp-types/InventoryType';
import { DashboardNotification } from '@sp-types/notificationType';
import { db } from './firebase';

export async function createInventory(data: IInventory) {
  console.log(data.accountId);
  if (!data.accountId) return;
  try {
    console.log(data);
    const docRef = await addDoc(collection(db, 'inventory'), data);
    console.log('Document written with ID: ', docRef.id);

    return docRef.id;
  } catch (err) {
    console.log(`error found! ${err}`);
  }
}

export async function getAccountInventory(accountId: string): Promise<IInventory | null> {
  const inventoryRef = collection(db, 'inventory');
  try {
    const q = query(inventoryRef, where('accountId', '==', accountId));
    const querySnapshot = await getDocs(q);
    if (!querySnapshot.empty) {
      const accountInventory: IInventory[] = querySnapshot.docs.map(createInventoryFromDoc);
      return accountInventory[0];
    } else {
      return null;
    }
  } catch (error) {
    console.error('Error getting documents:', error);
    return null;
  }
}

export async function updateAccountInventory(accountId: string, updatedInventory: IInventory) {
  try {
    console.log(updatedInventory);
    const inventoryRef = collection(db, 'inventory');
    const q = query(inventoryRef, where('accountId', '==', accountId));
    const querySnapshot = await getDocs(q);
    if (!querySnapshot.empty) {
      const updatedData = updatedInventory;
      const documentToUpdate = querySnapshot.docs[0].ref;
      await updateDoc(documentToUpdate, updatedData as any);
      console.log(`Account ${accountId} updated successfully.`);
    } else {
      console.log(`Order with ID '${accountId}' does not exist.`);
    }
  } catch (err) {
    console.error(`Error updating order property: ${err}`);
  }
}

export async function updateAccountMaterialInventoryList(accountId: string, updatedInventory: IMaterialInventory[]) {
  try {
    console.log(updatedInventory);
    const inventoryRef = collection(db, 'inventory');
    const q = query(inventoryRef, where('accountId', '==', accountId));
    const querySnapshot = await getDocs(q);
    if (!querySnapshot.empty) {
      const documentRef = querySnapshot.docs[0].ref;
      await updateDoc(documentRef, { materialInventory: updatedInventory });
      console.log(`Account ' updated successfully.`);
    } else {
      console.log(`Order with ID '${accountId}' does not exist.`);
    }
  } catch (err) {
    console.error(`Error updating order property: ${err}`);
  }
}

export async function addNotificationToAccount(accountId: string, newNotification: DashboardNotification) {
  try {
    const inventoryRef = collection(db, 'inventory');
    const q = query(inventoryRef, where('accountId', '==', accountId));
    const querySnapshot = await getDocs(q);
    if (!querySnapshot.empty) {
      const documentRef = querySnapshot.docs[0].ref;
      const documentData = querySnapshot.docs[0].data() as IInventory;
      // Create a new array with the existing notifications and the new notification
      const updatedNotifications = [...documentData.notifications, newNotification];

      // Update the document with the new notifications array
      await updateDoc(documentRef, { notifications: updatedNotifications });
      console.log(`Notification added to account ${accountId} successfully.`);
    } else {
      console.log(`Account with ID '${accountId}' does not exist.`);
    }
  } catch (err) {
    console.error(`Error adding notification to account: ${err}`);
  }
}

export async function deleteNotificationFromAccount(accountId: string, notificationIndex: number) {
  try {
    const inventoryRef = collection(db, 'inventory');
    const q = query(inventoryRef, where('accountId', '==', accountId));
    const querySnapshot = await getDocs(q);

    if (!querySnapshot.empty) {
      const documentRef = querySnapshot.docs[0].ref;
      const documentData = querySnapshot.docs[0].data() as IInventory;
      // Remove the notification from the array at the provided index
      const updatedNotifications = documentData.notifications.filter((_, index) => index !== notificationIndex);
      // Update the document with the new notifications array
      await updateDoc(documentRef, { notifications: updatedNotifications });
      console.log(`Notification at index ${notificationIndex} deleted from account ${accountId} successfully.`);
    } else {
      console.log(`Account with ID '${accountId}' does not exist.`);
    }
  } catch (err) {
    console.error(`Error deleting notification from account: ${err}`);
  }
}

export async function addStatusFileToAccount(accountId: string, fileReport: InventoryStatusFile) {
  try {
    const inventoryRef = collection(db, 'inventory');
    const q = query(inventoryRef, where('accountId', '==', accountId));
    const querySnapshot = await getDocs(q);
    if (!querySnapshot.empty) {
      const documentRef = querySnapshot.docs[0].ref;
      const documentData = querySnapshot.docs[0].data() as IInventory;
      const statusFiles = [...documentData.statusFiles, fileReport];

      await updateDoc(documentRef, { statusFiles });
      console.log(`status file added to account ${accountId} successfully.`);
    } else {
      console.log(`Account with ID '${accountId}' does not exist.`);
    }
  } catch (err) {
    console.error(`Error adding status file to account: ${err}`);
  }
}

const createInventoryFromDoc = (doc: DocumentSnapshot): IInventory => {
  const data = doc.data();

  // Convert timestamps in the notifications 0 to Date objects
  const notifications = (data!.notifications || []).map((notification: DashboardNotification) => {
    const date = (notification.date as any).toDate?.() || notification.date;
    return { ...notification, date: date };
  });

  return {
    materialInventory: data!.materialInventory,
    accountId: data!.accountId,
    notifications: notifications,
  } as IInventory;
};
